import { PropOptionSelect } from '@/models'
import { InfoDayModel } from '@/models/config'

const frequencyOptions: PropOptionSelect[] = [
    {
        value: 1,
        text: 'QUINCENAL'
    },
    {
        value: 2,
        text: 'MENSUAL'
    }
]

const documentTypes: PropOptionSelect[] = [
    {
        value: 1,
        text: 'DNI'
    },
    {
        value: 2,
        text: 'Carnet Extranjería'
    },
    {
        value: 3,
        text: 'Otros'
    }
]

const optionsConcubineTypes: PropOptionSelect[] = [
    {
        value: 0,
        text: 'No Aplica'
    },
    {
        value: 1,
        text: 'Cónyugue'
    },
    {
        value: 2,
        text: 'Concubino'
    }
]

const weekDays: InfoDayModel[] = [
    {
        key: 0,
        name: 'Domingo'
    },
    {
        key: 1,
        name: 'Lunes'
    },
    {
        key: 2,
        name: 'Martes'
    },
    {
        key: 3,
        name: 'Miércoles'
    },
    {
        key: 4,
        name: 'Jueves'
    },
    {
        key: 5,
        name: 'Viernes'
    },
    {
        key: 6,
        name: 'Sábado'
    }
]

const extensions_default = [
    'jpg',
    'png',
    'jpeg',
    'webp',
    'svg',
    'msg',
    'txt',
    'pdf',
    'doc',
    'docx',
    'odt',
    'csv',
    'xls',
    'xlsx',
    'ods',
    'ppt',
    'pptx',
    'ppsm',
    'potx',
    'odp',
    'mp3',
    'mp4',
    'avi',
    'mpg',
    'psd',
    'heic',
    'ai',
    'id',
    'iso',
    'html',
    'mdl',
    'dxf',
    'ads',
    'pds',
    'jfif'
]

const actionFormTypes: 'save'|'update' = 'save'

const getTextDocumentType = (id: number): string => {
    const op = documentTypes.find(d => d.value === id)
    if (op) {
        return op.text
    }
    return ''
}

const getTextConcubineType = (id: number): string => {
    const op = optionsConcubineTypes.find(op => op.value === id)
    if (op) {
        return op.text
    }
    return ''
}

export const reportsWithSignatures: PropOptionSelect[] = [
    {
        value: 1,
        text: 'Boletas de pago'
    }
]

export {
    documentTypes,
    optionsConcubineTypes,
    weekDays,
    extensions_default,
    frequencyOptions,
    actionFormTypes,
    getTextDocumentType,
    getTextConcubineType
}
